module.exports = __webpack_public_path__ + "static/media/white-leaf-in-circle.25cca274.svg";